import { render, staticRenderFns } from "./shareInventory.vue?vue&type=template&id=5e668ca0&scoped=true&"
import script from "./shareInventory.vue?vue&type=script&lang=js&"
export * from "./shareInventory.vue?vue&type=script&lang=js&"
import style0 from "./shareInventory.vue?vue&type=style&index=0&id=5e668ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e668ca0",
  null
  
)

component.options.__file = "shareInventory.vue"
export default component.exports